<template>
  <div class="basic_wrap">
    <bsHeader title="实名认证" />
    <form
      class="form"
      @submit.prevent="submit"
    >
      <div class="tip_box">
        <p class="tip_title">
          认证信息
        </p>
        <p class="tip_desc">
          请提交姓名、身份证号及身份证正反面，提交成功后即可用于商城下单。
        </p>
      </div>
      <div class="item">
        <input
          v-model.trim="name"
          type="text"
          class="inp"
          placeholder="请输入姓名"
        >
      </div>
      <div class="item m18">
        <input
          v-model.trim="idcard"
          type="text"
          class="inp"
          placeholder="请输入身份证号"
        >
      </div>
      <div class="upload_group">
        <label class="upload_card">
          <div
            v-if="idcardFrontPreview"
            class="preview_box"
          >
            <img
              :src="normalizePreview(idcardFrontPreview)"
              alt="身份证人像面"
            >
          </div>
          <div
            v-else
            class="upload_empty"
          >
            <p class="upload_title">身份证人像面</p>
            <p class="upload_desc">点击上传正面照片</p>
          </div>
          <input
            class="upload_input"
            type="file"
            accept="image/*"
            @change="onFileChange($event, 'front')"
          >
        </label>
        <label class="upload_card">
          <div
            v-if="idcardBackPreview"
            class="preview_box"
          >
            <img
              :src="normalizePreview(idcardBackPreview)"
              alt="身份证国徽面"
            >
          </div>
          <div
            v-else
            class="upload_empty"
          >
            <p class="upload_title">身份证国徽面</p>
            <p class="upload_desc">点击上传反面照片</p>
          </div>
          <input
            class="upload_input"
            type="file"
            accept="image/*"
            @change="onFileChange($event, 'back')"
          >
        </label>
      </div>
      <button
        type="submit"
        class="basic_btn sbtn"
        :class="submitDisabled ? 'no_touch' : ''"
      >
        {{ submitting ? '提交中...' : (isAuthed ? '已实名认证' : '立即认证') }}
      </button>
    </form>
  </div>
</template>

<script>
import Fetch from "../../utils/fetch";
import bsHeader from "../../components/bsHeader.vue";

export default {
  name: "UserAuth",
  components: {
    bsHeader
  },
  data() {
    return {
      name: "",
      idcard: "",
      idcardFront: "",
      idcardBack: "",
      idcardFrontPreview: "",
      idcardBackPreview: "",
      isAuthed: false,
      submitting: false,
      uploadingFront: false,
      uploadingBack: false
    };
  },
  computed: {
    submitDisabled() {
      return (
        this.submitting ||
        this.isAuthed ||
        this.uploadingFront ||
        this.uploadingBack ||
        !this.name ||
        !this.idcard ||
        !this.idcardFront ||
        !this.idcardBack
      );
    }
  },
  created() {
    this.$parent.footer("user", false);
  },
  mounted() {
    this.loadAuthInfo();
  },
  methods: {
    normalizePreview(url) {
      if (!url) {
        return "";
      }
      if (url.indexOf("data:image") === 0 || url.indexOf("http") === 0) {
        return url;
      }
      return url;
    },
    loadAuthInfo() {
      Fetch("/user/check_auth", {}, { method: "get" }, false).then(res => {
        var data = res.data || {};
        this.name = data.name || "";
        this.idcard = data.idcard || "";
        this.idcardFront = data.idcard_front || "";
        this.idcardBack = data.idcard_back || "";
        this.idcardFrontPreview = data.idcard_front || "";
        this.idcardBackPreview = data.idcard_back || "";
        this.isAuthed = data.is_auth === "Y";
      });
    },
    readFile(file, side) {
      var reader = new FileReader();
      reader.onload = e => {
        var result = e.target.result || "";
        if (side === "front") {
          this.idcardFrontPreview = result;
          this.idcardFront = "";
          this.uploadAuthImg(result, "front");
        } else {
          this.idcardBackPreview = result;
          this.idcardBack = "";
          this.uploadAuthImg(result, "back");
        }
      };
      reader.readAsDataURL(file);
    },
    uploadAuthImg(base64, side) {
      var loadingKey = side === "front" ? "uploadingFront" : "uploadingBack";
      var urlKey = side === "front" ? "idcardFront" : "idcardBack";
      var previewKey = side === "front" ? "idcardFrontPreview" : "idcardBackPreview";
      this[loadingKey] = true;
      Fetch("/user/upload_auth_img", {
        side: side,
        image: base64
      })
        .then(res => {
          var url = (res.data || {}).url || "";
          if (!url) {
            throw { msg: "图片上传失败" };
          }
          this[urlKey] = url;
        })
        .catch(() => {
          this[urlKey] = "";
          this[previewKey] = "";
        })
        .finally(() => {
          this[loadingKey] = false;
        });
    },
    onFileChange(event, side) {
      var files = event.target.files || [];
      if (!files.length) {
        return;
      }
      var file = files[0];
      if (file.size > 4 * 1024 * 1024) {
        this.$toast("图片不能超过4M");
        event.target.value = "";
        return;
      }
      this.readFile(file, side);
      event.target.value = "";
    },
    submit() {
      if (this.submitDisabled) {
        return false;
      }
      this.submitting = true;
      Fetch("/user/auth", {
        name: this.name,
        idcard: this.idcard,
        idcard_front: this.idcardFront,
        idcard_back: this.idcardBack
      }).then(() => {
        this.$toast({
          background: "#07c160",
          message: "认证成功"
        });
        if (this.$route.query.redirect) {
          this.$router.replace(this.$route.query.redirect);
        } else {
          this.$router.replace("/safe");
        }
      }).finally(() => {
        this.submitting = false;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.basic_wrap {
  padding-top: 44px;
}

.form {
  width: 100%;
  margin-top: 20px;
  padding: 0 20px 30px;
}

.tip_box {
  padding: 14px 16px;
  border-radius: 10px;
  background: #fff7f0;
  margin-bottom: 18px;
}

.tip_title {
  font-size: 16px;
  font-weight: 600;
  color: #222222;
}

.tip_desc {
  margin-top: 8px;
  font-size: 13px;
  line-height: 20px;
  color: #666666;
}

.m18 {
  margin-top: 18px;
}

.item {
  width: 100%;
  height: 45px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
}

.inp {
  flex: 1;
  padding: 0 12px;
  height: 22px;
  font-size: 16px;
  line-height: 22px;
}

.upload_group {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
}

.upload_card {
  position: relative;
  width: calc(50% - 6px);
  height: 132px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px dashed #fb661e;
  background: #ffffff;
}

.upload_input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.upload_empty {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 10px;
}

.upload_title {
  font-size: 15px;
  color: #222222;
  font-weight: 600;
}

.upload_desc {
  margin-top: 8px;
  font-size: 12px;
  color: #999999;
  line-height: 18px;
}

.preview_box {
  width: 100%;
  height: 100%;
}

.preview_box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.basic_btn {
  margin-top: 36px;
}
</style>
